import "./choosevacancymodal.scss";
import React from "react";
import { Modal } from "react-bootstrap";
import cross from "images/cross.svg";
import graybackarrow from "images/graybackarrow.svg";

import { inject, observer } from "mobx-react";

import CenterDateCard from "./CenterDateCard/index";
import { sendMetriks } from "utils/metriks";

const ChooseCenterDate = ({
  setModalShowVacancies,
  setSelectedVacancy,
  selectedVacancy,
  setSelectedCandidate,
  selectedCandidate,
  setSelectedCenter,
  setSelectedDate,
  selectedDate,
  vacancies,
  positions,
  cities,
  candidates,

  setSendApplicationModal,
  setModalShowCenterDate,
  setUpdateVacancyCandidateId,
  show,
  onHide
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Body className="choosecenterdate">
        <div className="choosecenterdate__top">
          <div
            className="choosecenterdate__top-back"
            onClick={() => {
              setModalShowVacancies(true);
              setModalShowCenterDate(false);
              setSelectedCenter("");
              setSelectedVacancy("");
              setSelectedDate("");
            }}
          >
            <img src={graybackarrow} alt="" />
            <p className="choosecenterdate__top-back-text">Назад</p>
          </div>
          <img
            src={cross}
            onClick={() => {
              setModalShowCenterDate(false);
              setSelectedCandidate("");
              setSelectedVacancy("");
              setSelectedCenter("");
              setSelectedDate("");
              setUpdateVacancyCandidateId("");
            }}
            alt=""
          />
        </div>
        <div className="choosevacancy-main">
          <p className="choosevacancy-title">
            Выберите город и дату прибытия
          </p>
          <div className="choosecenterdate-wrapper-text">
            <div className="choosevacancy-text">
              <p className="choosevacancy-subtitle">Кандидат:</p>
              <span className="choosevacancy-value">
                {candidates.length > 0
                  ? candidates.map((candidate) => {
                      if (candidate["id"] === selectedCandidate) {
                        return (
                          <span key={candidate.id}>
                            {candidate["surname"]} {candidate["name"]}{" "}
                            {candidate["patronymic"]}
                          </span>
                        );
                      }
                      return null;
                    })
                  : ""}
              </span>
            </div>
            <div className="choosevacancy-text">
              <p className="choosevacancy-subtitle">Вакансия:</p>
              {vacancies.length > 0 &&
                vacancies.map((vacancy) => {
                  if (
                    vacancy["id"] === selectedVacancy &&
                    positions[vacancy["position_id"]]
                  ) {
                    return (
                      <React.Fragment key={vacancy.id}>
                        <p className="choosevacancy-value">
                          {
                            positions[vacancy["position_id"]]["title"].split(
                              / (\d)/
                            )[0]
                          }
                        </p>
                        <p className="choosevacancy-value">
                          {cities[vacancy.city_id]["title"].length > 0 ? (
                            <>г. {cities[vacancy.city_id]["title"]}</>
                          ) : (
                            ""
                          )}
                        </p>
                      </React.Fragment>
                    );
                  }
                  return null;
                })}
            </div>
          </div>

          <CenterDateCard />

          <button
            onClick={() => {
              setModalShowCenterDate(false);
              setSendApplicationModal(true);
              sendMetriks("reachGoal", "resp_4");
            }}
            className="card-candidate-mainbtn"
            disabled={!selectedDate}
          >
            Выбрать
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ vacanciesStore, candidatesStore, modalWindows }) => {
  const {
    vacancies,
    allvacancies,
    positions,
    cities,
    statuses,
    getVacanciesData,
    error
  } = vacanciesStore;

  const {
    education_centers,
    candidates,
    setSelectedVacancy,
    selectedVacancy,
    setSelectedCandidate,
    selectedCandidate,
    setSelectedCenter,
    selectedCenter,
    setSelectedDate,
    selectedDate,
    getApplications,
    isLoading,
    setUpdateVacancyCandidateId
  } = candidatesStore;

  const {
    setSendApplicationModal,
    setModalShowCenterDate,
    setModalShowVacancies
  } = modalWindows;
  return {
    vacancies,
    getApplications,
    allvacancies,
    getVacanciesData,
    positions,
    cities,
    statuses,
    education_centers,
    candidates,
    setSelectedVacancy,
    selectedVacancy,
    setSelectedCandidate,
    selectedCandidate,
    setSelectedCenter,
    selectedCenter,
    setSelectedDate,
    selectedDate,
    error,
    isLoading,
    setUpdateVacancyCandidateId,
    setSendApplicationModal,
    setModalShowCenterDate,
    setModalShowVacancies
  };
})(observer(ChooseCenterDate));
